function setActiveVariant(event){
    var allVariants = document.querySelectorAll('.variant-field');
    for(var i = 0; i < allVariants.length; i++){
        allVariants[i].classList.remove('active');
    }
    event.currentTarget.classList.add('active');
}

function checkNewsletterEmail(event){
    var submitBtn = document.querySelector('.newsletter-signup .btn.caps');
    event.currentTarget.value && event.currentTarget.value.length > 0 ? submitBtn.removeAttribute('disabled')
        : submitBtn.setAttribute('disabled', 'disabled') ;
}

window.addEventListener('load', function () {
    jQuery(window).scroll(function () {
        var descBoxOffset = jQuery('.grid.product__page').offset();
        if(descBoxOffset){
            var descBox = document.querySelector('.product-description.rte');
            if(window.innerWidth > 767){
                if (jQuery(window).scrollTop() >= descBoxOffset.top) {
                    descBox.classList.add('collapse');
                    jQuery('.form__wrapper').css({"height": "260px"});
                } else {
                    descBox.classList.remove('collapse');
                    jQuery('.form__wrapper').css({"height": "500px"});
                }
            }
        }
    });
});

function changeCurrency(el){
    console.log(el)
    window.localStorage.setItem('cur-custom', el);
    updateLinks(el)
  }
  function updateLinks(val){
    var productLinks = document.querySelectorAll('.product-grid a.product-link');
    var productTitles = document.querySelectorAll('.product-grid a.product-link .product__grid__title');
    var priceTexts = document.querySelectorAll('.product-grid a.product-link .product-information .price');

    if(val === 'INR'){
         $.getJSON('https://shopindia.gundistudios.com/collections/all/products.json',function(data){
            console.log(data.products)
            if(data.products && data.products.length > 0){
              for(var i=0;i<productLinks.length;i++){
                var productTitle = productLinks[i].querySelector('.product__grid__title').innerHTML;
                var productPrice = productLinks[i].querySelector('.product-information .price');
                var matchingProduct = data.products.find(el => el.title.trim().toLowerCase() === productTitle.trim().toLowerCase());

                if(matchingProduct)
                  productPrice.innerHTML = 'INR '+  matchingProduct.variants[0].price;
              }
            }
            
          });
      } else {
          $.getJSON('https://gundistudios.myshopify.com/collections/all/products.json',function(data){
             console.log(data.products)
             if(data.products && data.products.length > 0){
               for(var i=0;i<productLinks.length;i++){
                 var productTitle = productLinks[i].querySelector('.product__grid__title').innerHTML;
                 var productPrice = productLinks[i].querySelector('.product-information .price');
                 var matchingProduct = data.products.find(el => el.title.trim().toLowerCase() === productTitle.trim().toLowerCase())
                 
                 if(matchingProduct)
                  productPrice.innerHTML = '$ '+  matchingProduct.variants[0].price;
               }
             }
             
           });
      }
    
    // if(val === 'INR'){
    //    $.getJSON('https://shopindia.gundistudios.com/collections/all/products.json',function(data){
    //       console.log(data.products)
    //       for(var i=0;i<priceTexts.length;i++){
    //         if(data.products[i]){
    //         console.log(data.products[i].variants[0].price)
    //         priceTexts[i].innerHTML = 'INR '+  data.products[i].variants[0].price
    //         }
    //       }
    //     })
    // }else{
    //   $.getJSON('https://gundistudios.myshopify.com/collections/all/products.json',function(data){
    //       console.log(data.products)
    //       for(var i=0;i<priceTexts.length;i++){
    //         if(data.products[i]){
    //         console.log(data.products[i].variants[0].price)
    //         priceTexts[i].innerHTML = '$ '+  data.products[i].variants[0].price
    //         }
    //       }
    //     })
    // }
    for(var i=0;i<productLinks.length;i++){
      if(val === 'INR'){
        productLinks[i].hostname = 'shopindia.gundistudios.com';
      }else{
        productLinks[i].hostname = 'www.gundistudios.com';
      }
    }
    
  }
  (function(){
    // var currencySelected = window.localStorage.getItem('cur-custom');
    // if(currencySelected){
    //   document.querySelector('.action-item-select [value="' + currencySelected + '"]').selected = true;
    // }
  })();